:host {
    --wcs-list-item-property-font-weight: var(--wcs-semantic-font-weight-medium);
    --wcs-list-item-property-color: var(--wcs-semantic-color-text-secondary);

    font-weight: var(--wcs-list-item-property-font-weight);
    color: var(--wcs-list-item-property-color);
}
